module.exports = __webpack_public_path__ + "static/img/101010.83d7d6ef.png";